export const GridFilterPages = {
  VisitActuals: 'Visit Actuals',
  Patients: 'Patients',
  NonPatientActivities: 'NonPatientActivities',
};
